import React, { createContext, useContext } from 'react';
import { getArtistOfferCount } from '../api/artistCounts';
import { useArtistAuth } from './ArtistAuthContext';
import { useBadgeQuery } from './BadgeResourceContext';

const OfferCountContext = createContext();

export const OfferCountProvider = ({ children }) => {
  const { artistUser, checking } = useArtistAuth() || {};
  const { data: offerCount, refresh: refreshOfferCount } = useBadgeQuery({
    queryKey: ['artist-offer-count'],
    enabled: Boolean(artistUser?.userId ?? artistUser?.id) && !checking,
    visible: Boolean(artistUser?.userId ?? artistUser?.id),
    initialValue: 0,
    queryFn: async () => {
      const data = await getArtistOfferCount();
      if (typeof data?.count !== 'number' || !Number.isSafeInteger(data.count) || data.count < 0) {
        throw new Error('Invalid artist offer count');
      }
      return data.count;
    },
  });
  return <OfferCountContext.Provider value={{ offerCount, refreshOfferCount }}>{children}</OfferCountContext.Provider>;
};

export const useOfferCount = () => useContext(OfferCountContext);
